var _rect, _path, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11645_4216",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11645_4216)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3 3.1C9.59186 1.90182 10.863 1 12.387 1C13.9109 1 15.1821 1.90182 15.474 3.1H19.9C21.0046 3.1 21.9 3.99543 21.9 5.1V20C21.9 21.1046 21.0046 22 19.9 22H5C3.89543 22 3 21.1046 3 20V5.1C3 3.99543 3.89543 3.1 5 3.1H9.3ZM19.9 5.1L5 5.1L5 20L19.9 20L19.9 5.1ZM12.45 4.15C13.0299 4.15 13.5 3.6799 13.5 3.1C13.5 2.5201 13.0299 2.05 12.45 2.05C11.8701 2.05 11.4 2.5201 11.4 3.1C11.4 3.6799 11.8701 4.15 12.45 4.15Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11645_4216",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11645_4216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14.6008L16.9 8.70078C17.0834 8.51745 17.3167 8.42578 17.6 8.42578C17.8834 8.42578 18.1167 8.51745 18.3 8.70078C18.4834 8.88411 18.575 9.11745 18.575 9.40078C18.575 9.68411 18.4834 9.91745 18.3 10.1008L11.7 16.7008C11.5 16.9008 11.2667 17.0008 11 17.0008C10.7334 17.0008 10.5 16.9008 10.3 16.7008L7.70005 14.1008C7.51672 13.9174 7.42505 13.6841 7.42505 13.4008C7.42505 13.1174 7.51672 12.8841 7.70005 12.7008C7.88338 12.5174 8.11672 12.4258 8.40005 12.4258C8.68338 12.4258 8.91672 12.5174 9.10005 12.7008L11 14.6008Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.807f550b0b643e36470fa86b35ead532.svg";
export { ForwardRef as ReactComponent };